import React from 'react'
import styles from './pupils-component.styles'
import injectSheet from 'react-jss'
import PupilsFilterControls from './pupils-filter-controls/pupils-filter-controls.container'
import PupilsSearch from './pupils-search/pupils-search.container'
import PupilsTable from './pupils-table/pupils-table.container'
import PupilsFilter from './pupils-filter-dialog/pupils-filter-dialog.container'
import AddPupilButton from './add-pupil-button/add-pupil-button'
import NoPupils from './no-pupils/no-pupils'

const PupilsComponent = ({
  classes,
  actualPupilsListEmpty,
  filteredPupilsEmpty,
  style,
  selectedPupils,
  isShowingSelected,
  showAll,
  canAddPupil
}) =>
  actualPupilsListEmpty ? (
    <div style={style}>
      <NoPupils />
    </div>
  ) : (
    <div style={style}>
      {!isShowingSelected && (
        <div className={classes.filterControlsContainer}>
          <PupilsFilterControls />
        </div>
      )}
      {isShowingSelected && (
        <div className={classes.showingSelectedHolder}>
          <span className={classes.selectedWarning}>
            You are seeing only selected pupils.
          </span>
          <span className={classes.showAllPupils} onClick={showAll}>
            Show all
          </span>
        </div>
      )}
      <div className={classes.topPanel}>
        <div className={classes.searchHolder}>
          <PupilsSearch disabled={isShowingSelected} />
        </div>
        {canAddPupil && (
          <div className={classes.addPupilHolder}>
            <AddPupilButton disabled={isShowingSelected} />
          </div>
        )}
      </div>
      {!actualPupilsListEmpty &&
        filteredPupilsEmpty && (
          <div className={classes.pupilsMessage}>
            No pupil matching those criteria
          </div>
        )}
      {!actualPupilsListEmpty && !filteredPupilsEmpty && <PupilsTable />}
      <PupilsFilter />
    </div>
  )

export default injectSheet(styles)(PupilsComponent)
